import { ThemeEvents } from '@theme/events';

const scopeSelector = 'product-card, .product-details, quick-add-dialog, .featured-product-section, .shopify-section';

class MerchandisingMessages extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest(scopeSelector);
    this.scope?.addEventListener(ThemeEvents.variantSelected, this.onSelected);
    this.scope?.addEventListener(ThemeEvents.variantUpdate, this.onUpdate);
  }

  disconnectedCallback() {
    this.scope?.removeEventListener(ThemeEvents.variantSelected, this.onSelected);
    this.scope?.removeEventListener(ThemeEvents.variantUpdate, this.onUpdate);
  }

  ownsEvent = (event) => event.target instanceof Element && event.target.closest(scopeSelector) === this.scope;

  onSelected = (event) => {
    if (!this.ownsEvent(event)) return;
    this.querySelectorAll('[data-variant-dependent]').forEach((badge) => { badge.hidden = true; });
  };

  onUpdate = (event) => {
    if (!this.ownsEvent(event)) return;
    const data = event.detail?.data;
    if (!data?.html) return;
    const productId = String(data.newProduct?.id ?? data.productId ?? this.dataset.productId);
    if (!data.newProduct && productId !== this.dataset.productId) return;
    const source = Array.from(data.html.querySelectorAll('merchandising-messages')).find((node) =>
      node.dataset.productId === productId &&
      node.dataset.context === this.dataset.context &&
      node.dataset.position === this.dataset.position
    );
    this.dataset.productId = productId;
    this.replaceChildren(...(source ? Array.from(source.childNodes, (node) => node.cloneNode(true)) : []));
    this.dataset.variantRefresh = source?.dataset.variantRefresh ?? 'false';
  };
}

if (!customElements.get('merchandising-messages')) {
  customElements.define('merchandising-messages', MerchandisingMessages);
}

const cardRequests = new WeakMap();

document.addEventListener('change', async (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches('product-card-variant-selector input[data-variant-id]')) return;
  const card = input.closest('product-card');
  if (!card?.querySelector('merchandising-messages[data-context="Product card"][data-variant-refresh="true"]')) return;
  const link = card.querySelector('a[data-paragon-product-card-link]');
  if (!link?.getAttribute('href')) return;
  cardRequests.get(card)?.abort();
  const controller = new AbortController();
  cardRequests.set(card, controller);
  const groups = Array.from(card.querySelectorAll('merchandising-messages'));
  groups.forEach((group) => group.onSelected({ target: input }));
  const url = new URL(link.getAttribute('href'), window.location.origin);
  url.searchParams.set('variant', input.dataset.variantId);
  url.searchParams.set('section_id', 'section-rendering-product-card');
  try {
    const response = await fetch(url, { signal: controller.signal });
    if (!response.ok) throw new Error(`Merchandising refresh failed: ${response.status}`);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    if (controller.signal.aborted || !card.isConnected) return;
    groups.forEach((group) => group.onUpdate({ target: input, detail: { data: { html, productId: group.dataset.productId } } }));
  } catch (error) {
    if (error.name !== 'AbortError') console.warn('Unable to refresh merchandising messages. Variant-dependent messages remain hidden.');
  } finally {
    if (cardRequests.get(card) === controller) cardRequests.delete(card);
  }
});
